import React, { useEffect, useState, useRef } from "react";
import "../../Styles/CommonStyles.scss";
import {
  Button,
  Label,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import DSBAlogo from "../../Images/DSBAlogo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import RoundButtonWithIcon from "../StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
import eventApiSlice, { IEvent } from "../../store/eventApiSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import dayjs, { Dayjs } from "dayjs";
import ReportServices from "../../services/ReportServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { createTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";

interface Iprops {
  //callBackClose: () => void;
}


interface AdvanceMemberCodeData {
  BarId: number;
  FullName: string;
  YearAdmitted: number;
  MemberCode: string;
  AdvanceMemberCode: string;
}


const MemberCodeAdvancementReport: React.FC<Iprops> = (props) => {

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const eventInfo: IEvent = useSelector(
    (state: RootState) => state.eventapislice.event
  );

  const [membershipData, setMembershipData] = useState<AdvanceMemberCodeData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [totalRecord, setTotalRecord] = useState<number | 0>(0);
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [totalPages, setTotalPages] = useState<number>(1);

  const color1 = "#2d6289"; // Use the same color as in FMPersonalInfo

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              // Left: "-4%",
              // Top: "10%",
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
              Left: "-4% !important",
              Top: "10%",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

    // Fetch data with pagination
    const fetchMembershipData = async (pageNum = page, limitNum = rowsPerPage) => {
      setLoading(true);
      setError(null);
      try {
        // You may need to update the backend to accept pagination params for this report
        const response = await ReportServices.fetchAdvanceMemberCodeReport(pageNum, limitNum);
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          setMembershipData(response.data.data.data);
          setTotalRecord(response.data.data.pagination.total);
          setTotalPages(response.data.data.pagination.totalPages);
        } else {
          setError("Error fetching data: " + response.data.errors.join(","));
        }
      } catch (err) {
        setError("API call failed: " + err);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchMembershipData(page, rowsPerPage);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage]);

  const PrintLabelRef = useRef<HTMLDivElement>(null);

  function downloadExcel(url: string, filename: string, apiKey: string) {
    fetch(url, {
      method: 'GET',
      headers: {
        'APIKey': apiKey
      }
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.blob();
      })
      .then(blob => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(link.href);
      })
      .catch(err => {
        alert('Download failed: ' + err.message);
      });
  }
  

  // Excel Export logic
  const handleExportExcel = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await ReportServices.downloadExcelForMemberCodeAdvancement();
    } catch (err) {
      setError("Download failed: " + err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = useReactToPrint({ content: () => PrintLabelRef.current });

  return (
    <>
      <div
        className="horizontal-wrapper-spacebetween"
        style={{ alignItems: "center" }}
      >
        <h1 className="page-heading d-block" style={{ height: "auto" }}>
          Member Code Advancement Report ({totalRecord + " Members"})
        </h1>
        <div
          className="horizontal-wrapper-rightaligned"
          style={{
            width: "auto",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <SecondaryWhiteButton
            className="button-wrapper"
            type="button"
            style={{
              marginRight: ".5rem",
              marginLeft: ".5rem",
            }}
            onClick={handleExportExcel}
          >
            <span style={{ fontWeight: "500" }}>Export to Excel</span>
          </SecondaryWhiteButton>
        </div>
        
        <div className="container" style={{ display: "block" }}>
          <div className="memberlist-table" style={{ paddingTop: "0px", maxHeight: "400px", overflowY: "auto" }} ref={PrintLabelRef}>
            <h1 className="print-header page-heading" style={{ height: "auto" }}>
              Member Code Advancement Report
            </h1>
            <table className="eventlist-table" style={{ tableLayout: "fixed", width: "100%" }}>
              <thead className="table-border" style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                <tr style={{ height: "auto", whiteSpace: "normal" }}>
                  <th style={{ width: "30%", textAlign: "left", background: "#04aa6d", position: 'sticky', top: 0, zIndex: 3 }}>BarId</th>
                  <th style={{ width: "20%", textAlign: "left", background: "#04aa6d", position: 'sticky', top: 0, zIndex: 3 }}>FullName</th>
                  <th style={{ width: "20%", textAlign: "left", background: "#04aa6d", position: 'sticky', top: 0, zIndex: 3 }}>Years Admitted</th>
                  <th style={{ width: "30%", textAlign: "left", background: "#04aa6d", position: 'sticky', top: 0, zIndex: 3 }}>Member Code</th>
                  <th style={{ width: "30%", textAlign: "left", background: "#04aa6d", position: 'sticky', top: 0, zIndex: 3 }}>Advance Member Code</th>
                </tr>
              </thead>
              <tbody className="table-border">
                {membershipData.map(item => (
                  <tr key={item.BarId}>
                    <td style={{ textAlign: "left" }}>{item.BarId}</td>
                    <td style={{ textAlign: "left" }}>{item.FullName}</td>
                    <td style={{ textAlign: "left" }}>{item.YearAdmitted}</td>
                    <td style={{ textAlign: "left" }}>{item.MemberCode}</td>
                    <td style={{ textAlign: "left" }}>{item.AdvanceMemberCode}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Pagination Controls styled exactly like MembershipPendingPaymentReport */}
        <div className="grid pagination-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: 10 }}>
          <div className="grid left" style={{ flex: 1 }}></div>
          <div className="grid center" style={{ flex: 2, display: 'flex', justifyContent: 'center' }}>
            <div className="horizontal-wrapper-centeraligned" style={{ display: 'flex', alignItems: 'center' }}>
              <div
                className="round-button-div"
                style={{ width: "30px", height: "30px", marginRight: "10px" }}
              >
                <RoundButtonWithIcon
                  icon={<LeftArrowIcon height={15} width={8} />}
                  onClick={() => setPage(page - 1)}
                  disabled={page === 1}
                />
              </div>
              <div className="heading_medium">
                <span style={{ fontWeight: "500" }}>
                  {totalRecord === 0 ? 0 : 1 + (page - 1) * rowsPerPage}
                </span>
                {" - "}
                <span style={{ fontWeight: "500" }}>
                  {Math.min(page * rowsPerPage, totalRecord)}
                </span>
                {" of "}
                <span style={{ fontWeight: "500" }}>{totalRecord}</span> members
              </div>
              <div
                style={{ height: "30px", width: "30px", marginLeft: "10px", transform: "rotate(180deg)" }}
              >
                <RoundButtonWithIcon
                  icon={<LeftArrowIcon height={15} width={8} />}
                  onClick={() => setPage(page + 1)}
                  disabled={page === totalPages || totalRecord === 0}
                />
              </div>
            </div>
          </div>
          <div className="grid right" style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <select
              className="dropdown-control-large-insidetextfield"
              name="pagesize"
              style={{ border: "1px solid #ddd" }}
              onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(1); }}
              value={rowsPerPage}
            >
              <option value={10}>10 rows</option>
              <option value={25}>25 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
              <option value={150}>150 rows</option>
              <option value={200}>200 rows</option>
            </select>
          </div>
          </div>
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default MemberCodeAdvancementReport;
